import { gql } from "@apollo/client";
import { BundleProductFragment } from "../../RootComponents/Product/BundleProductFragment.gql";

const GET_YOUMAYALSOLIKE_PRODUCTS = gql`
  query youMayALsoLike($skus: [String!]) {
    products(filter: { sku: { in: $skus } }) {
      items {
        uid
        name
        crosssell_products {
          id
          attribute_set_id
          name
          unit_text
          flag_text
          url_key
          stock_status
          type_id
          enable_site_visit
          enable_appliance_site_visit
          description {
            html
          }
          short_description {
            html
          }
          meta_title
          meta_description
          sku
          uid
          categories {
            name
            url_key
          }
          image {
            url
            label
          }
          small_image {
            url
            label
          }
          review_count
          rating_summary
          uid
          media_gallery {
            url
            label
            ... on ProductVideo {
              video_content {
                media_type
                video_provider
                video_url
                video_title
                video_description
                video_metadata
              }
            }
          }
          ... on BundleProduct {
            ...BundleProductFields
          }
          ... on CustomizableProductInterface {
            options {
              title
              required
              sort_order
              uid
              ... on CustomizableFieldOption {
                textField: value {
                  sku
                  uid
                  price
                }
              }
              ... on CustomizableCheckboxOption {
                dropDown: value {
                  option_type_id
                  price
                  price_type
                  sku
                  sort_order
                  title
                  uid
                }
              }
            }
          }

          __typename

          media_gallery {
            url
            label
          }
          ... on CustomizableProductInterface {
            options {
              title
              required
              sort_order
              option_id
              ... on CustomizableDropDownOption {
                value {
                  option_type_id
                  price
                  price_type
                  sku
                  sort_order
                  title
                }
              }
            }
          }
          price_range {
            minimum_price {
              regular_price {
                value
                currency
              }
              final_price {
                value
                currency
              }
              discount {
                amount_off
                percent_off
              }
            }
            maximum_price {
              regular_price {
                value
                currency
              }
              final_price {
                value
                currency
              }
              discount {
                amount_off
                percent_off
              }
            }
          }
          simplebundle
          ... on ConfigurableProduct {
            configurable_options {
              id
              uid
              attribute_id
              label
              position
              use_default
              attribute_code
              values {
                value_index
                uid
                default_label
                label
                store_label
                use_default_value
                swatch_data {
                  ... on ImageSwatchData {
                    thumbnail
                  }
                  value
                }
              }
              product_id
            }
            variants {
              attributes {
                uid
                label
                code
                value_index
              }
              product {
                id
                name
                uid
                unit_text
                media_gallery {
                  url
                  label
                }
                sku
                stock_status
                attribute_set_id
                ... on PhysicalProductInterface {
                  weight
                }
                price_range {
                  minimum_price {
                    regular_price {
                      value
                      currency
                    }
                    final_price {
                      value
                      currency
                    }
                    discount {
                      amount_off
                      percent_off
                    }
                  }
                  maximum_price {
                    regular_price {
                      value
                      currency
                    }
                    final_price {
                      value
                      currency
                    }
                    discount {
                      amount_off
                      percent_off
                    }
                  }
                }
              }
              attributes {
                label
                code
                value_index
              }
            }
          }
        }
      }
    }
  }
  ${BundleProductFragment}
`;

export default {
  getYouMayAlsoLikeQuery: GET_YOUMAYALSOLIKE_PRODUCTS,
};
